module.exports = __webpack_public_path__ + "static/media/img4-3.04b1e7ba.png";